<template>
  <div>
    <div class="menu-toggle">
      <Button type="text" @click="toggleClick" class="toggleBtn">
				<Icon type="navicon" size="32"></Icon>
			</Button>
    </div>
    <el-menu mode="vertical" theme="dark" unique-opened :default-active="$route.path" :collapse="!opened">
      <template v-for="item in menus">
        <router-link v-if="!item.haveSubMenu" :to="item.path+'/'+item.children[0].path"
          :key="item.path+'/'+item.children[0].path">
          <el-menu-item :index="item.path+'/'+item.children[0].path" class='submenu-title-noDropdown'>
            <Icon :type="item.icon"></Icon>
            <span>{{$t(item.meta.title)}}</span>
          </el-menu-item>
        </router-link>
        <el-submenu v-else :key="item.path" :index="item.path">
          <template slot="title">
            <Icon :type="item.icon"></Icon>
            <span>{{$t(item.meta.title)}}</span>
          </template>
          <template v-for="child in item.children">
            <router-link v-if="!child.hideMenu" :to="item.path+'/'+child.path" :key="item.path+'/'+child.path">
              <el-menu-item :index="item.path+'/'+child.path">{{$t(child.meta.title)}}</el-menu-item>
            </router-link>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: 'SideBar',
  data () {
    return {
    }
  },
  props: ['menus', 'opened'],
  methods: {
    toggleClick () {
      this.$store.dispatch('ToggleSideBar')
    }
  }
}
</script>
<style lang="scss">
  .menu-toggle {
    background-color: #363e4f;
    text-align: center;
  }
  .sidebar-container .el-menu {
    background-color: #495060;
    border-radius: 0px;
  }
  .sidebar-container .el-menu .el-submenu .el-menu {
    background-color: #363e4f;
  }
  .sidebar-container .el-menu-item.is-active {
    border-right: none;
    color: #fff;
    background: #2d8cf0!important;
  }
  .sidebar-container .el-menu .el-submenu .el-menu-item:hover {
    color: #fff;
    background-color: transparent;
  }

  .sidebar-container>.el-menu {
    width: 100%!important;
    min-height: 100%;
  }

  .sidebar-container i.ivu-icon {
    transition: all 0.28s ease-out;
    margin-right: 10px;
  }

  .hideSidebar .sidebar-container i.ivu-icon {
    font-size: 26px;
    margin-right: 0px;
  }

  .hideSidebar .submenu-title-noDropdown span,
  .hideSidebar .el-submenu>.el-submenu__title>span {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
  }

  .hideSidebar .nest-menu .el-submenu__title {
    text-align: initial!important;
    padding-left: 20px!important;
    span {
      visibility: visible;
      display: inline;
    }
    .el-submenu__icon-arrow {
      display: block!important;
    }
  }
  .hideSidebar .el-menu-item,
  .hideSidebar .submenu-title-noDropdown,
  .hideSidebar .el-submenu .el-submenu__title {
    text-align: center;
  }
  .hideSidebar .el-menu-item .el-submenu__icon-arrow,
  .hideSidebar .el-submenu .el-submenu__title .el-submenu__icon-arrow {
    display: none;
  }
  // .hideSidebar .submenu-title-noDropdown {
  //   position: relative;
  //   span {
  //     transition: opacity .3s cubic-bezier(.55, 0, .1, 1);
  //     opacity: 0;
  //   }
  //   &:hover {
  //     span {
  //       display: block;
  //       border-radius: 3px;
  //       z-index: 1002;
  //       width: 140px;
  //       height: 56px;
  //       visibility: visible;
  //       position: absolute;
  //       right: -145px;
  //       text-align: left;
  //       text-indent: 20px;
  //       top: 0px;
  //       background-color: #363e4f;
  //       opacity: 1;
  //     }
  //   }
  // }
</style>





// WEBPACK FOOTER //
// SideBar.vue?162d8fc1